import React from 'react'
import Helpers from '../../../../libs/helpers'

export default function (props) {
    let randomId = Helpers.getRandomString();
    return (
        <div className={'names'}>
            <label htmlFor={randomId}>{props.name}</label>
            <input type="text" placeholder={props.name} required id={randomId}/>
        </div>
    )
}